<template>

    <div id="user-settings">
        <h1>User Settings</h1>
        <section class="user-data-display">
            <div class="row">
                <div class="col-xs-12 col-sm-2 fullname"><b>Name:</b></div>
                <div class="col-xs-10 col-sm-9 name-input-group" v-if="edit.name">
                    <input class="form-control" type="text" placeholder="First Name" v-model="user.firstName">
                    <input class="form-control" type="text" palceholder="Last Name" v-model="user.lastName">
                </div>
                <div class="col-xs-10 col-sm-9" v-else>{{ user.firstName }} {{ user.lastName }}</div>
                <div class="col-xs-2 col-sm-1"><button class="btn btn-default btn-xs" @click="toggleEdit('name')"><i class="fa fa-pencil"></i></button></div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-2 fullname"><b>Email:</b></div>
                <div class="col-xs-10 col-sm-9 name-input-group" v-if="edit.email">
                    <input class="form-control" type="text" placeholder="Email Address" v-model="user.email">
                </div>
                <div class="col-xs-10 col-sm-9" v-else>{{ user.email }}</div>
                <div class="col-xs-2 col-sm-1"><button class="btn btn-default btn-xs" @click="toggleEdit('email')"><i class="fa fa-pencil"></i></button></div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-2 fullname"><b>Password:</b></div>
                <div class="col-xs-10 col-sm-9 name-input-group" v-if="edit.password">
                    <input class="form-control" type="password" placeholder="Password" v-model="user.password">
                </div>
                <div class="col-xs-10 col-sm-9" v-else>&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;</div>
                <div class="col-xs-2 col-sm-1"><button class="btn btn-default btn-xs" @click="toggleEdit('password')"><i class="fa fa-pencil"></i></button></div>
            </div>
            <div class="row">
                <div class="change-password col-xs-12">
                    <button class="btn btn-primary" @click="saveUserData()">Save Changes</button>
                    <router-link to="/" class="btn btn-warning">Done</router-link>
                </div>
            </div>
        </section>
    </div>

</template>



<script>

    import { Store } from '@/store.js'
    import UserService from '@/services/user.service'

    export default {

        name: 'UserSettings',
        
        data() {
            return {
                store: Store,
                user:{},
                edit: {
                    name: false,
                    email: false,
                    password: false
                }
            }
        },

        created: function() {
            this.getUser();
        },

        methods: {

            toggleEdit: function (prop) {
                this.edit[prop] = !this.edit[prop]
            },

            getUser: function() {
                UserService.get().then( user => this.user = $.extend(true, {}, user) );
            },

            saveUserData: function() {
                UserService.updateUser(this.user)
                    .then(this.disableEditMode);
            },

            disableEditMode: function() {
                this.edit.name = false;
                this.edit.email = false;
                this.edit.password = false;
            }
        }
    }

</script>



<style lang="scss">

    @import "../variables";

    .user-data-display {
        text-align: left;

        .row {
            line-height: 2em;
            margin-bottom:5px;
        }

        .change-password {
            padding: 1em 0;
            text-align: center;
        }

        .name-input-group {
            display: flex;

            input {
                margin-right: 5px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// UserSettings.vue?154ff2a5